import { defineComponent as G, h as s, computed as p } from "vue";
import { useRtl as J } from "./highrise1067.mjs";
import { resolveWrappedSlot as i, ensureValidVNode as c } from "./highrise1059.mjs";
import Q from "./highrise1079.mjs";
import U from "./highrise1053.mjs";
import v from "./highrise984.mjs";
import { createKey as b } from "./highrise314.mjs";
import { getMargin as X } from "./highrise1080.mjs";
import { useThemeClass as Y } from "./highrise1062.mjs";
import { keysOf as Z } from "./highrise1054.mjs";
import ee from "./highrise1081.mjs";
import { call as oe } from "./highrise1077.mjs";
import te from "./highrise989.mjs";
const S = {
  title: [String, Function],
  contentClass: String,
  contentStyle: [Object, String],
  headerClass: String,
  headerStyle: [Object, String],
  headerExtraClass: String,
  headerExtraStyle: [Object, String],
  footerClass: String,
  footerStyle: [Object, String],
  embedded: Boolean,
  segmented: {
    type: [Boolean, Object],
    default: !1
  },
  size: {
    type: String,
    default: "medium"
  },
  bordered: {
    type: Boolean,
    default: !0
  },
  closable: Boolean,
  hoverable: Boolean,
  role: String,
  onClose: [Function, Array],
  tag: {
    type: String,
    default: "div"
  },
  cover: Function,
  content: [String, Function],
  footer: Function,
  action: Function,
  headerExtra: Function
}, be = Z(S), re = Object.assign(Object.assign({}, v.props), S), pe = G({
  name: "Card",
  props: re,
  slots: Object,
  setup(o) {
    const f = () => {
      const {
        onClose: r
      } = o;
      r && oe(r);
    }, {
      inlineThemeDisabled: a,
      mergedClsPrefixRef: e,
      mergedRtlRef: g
    } = U(o), d = v("Card", "-card", Q, te, o, e), u = J("Card", g, e), h = p(() => {
      const {
        size: r
      } = o, {
        self: {
          color: t,
          colorModal: l,
          colorTarget: C,
          textColor: m,
          titleTextColor: y,
          titleFontWeight: x,
          borderColor: $,
          actionColor: z,
          borderRadius: E,
          lineHeight: R,
          closeIconColor: _,
          closeIconColorHover: B,
          closeIconColorPressed: P,
          closeColorHover: F,
          closeColorPressed: O,
          closeBorderRadius: j,
          closeIconSize: T,
          closeSize: I,
          boxShadow: V,
          colorPopover: k,
          colorEmbedded: H,
          colorEmbeddedModal: w,
          colorEmbeddedPopover: M,
          [b("padding", r)]: N,
          [b("fontSize", r)]: K,
          [b("titleFontSize", r)]: L
        },
        common: {
          cubicBezierEaseInOut: W
        }
      } = d.value, {
        top: A,
        left: D,
        bottom: q
      } = X(N);
      return {
        "--n-bezier": W,
        "--n-border-radius": E,
        "--n-color": t,
        "--n-color-modal": l,
        "--n-color-popover": k,
        "--n-color-embedded": H,
        "--n-color-embedded-modal": w,
        "--n-color-embedded-popover": M,
        "--n-color-target": C,
        "--n-text-color": m,
        "--n-line-height": R,
        "--n-action-color": z,
        "--n-title-text-color": y,
        "--n-title-font-weight": x,
        "--n-close-icon-color": _,
        "--n-close-icon-color-hover": B,
        "--n-close-icon-color-pressed": P,
        "--n-close-color-hover": F,
        "--n-close-color-pressed": O,
        "--n-border-color": $,
        "--n-box-shadow": V,
        // size
        "--n-padding-top": A,
        "--n-padding-bottom": q,
        "--n-padding-left": D,
        "--n-font-size": K,
        "--n-title-font-size": L,
        "--n-close-size": I,
        "--n-close-icon-size": T,
        "--n-close-border-radius": j
      };
    }), n = a ? Y("card", p(() => o.size[0]), h, o) : void 0;
    return {
      rtlEnabled: u,
      mergedClsPrefix: e,
      mergedTheme: d,
      handleCloseClick: f,
      cssVars: a ? void 0 : h,
      themeClass: n == null ? void 0 : n.themeClass,
      onRender: n == null ? void 0 : n.onRender
    };
  },
  render() {
    const {
      segmented: o,
      bordered: f,
      hoverable: a,
      mergedClsPrefix: e,
      rtlEnabled: g,
      onRender: d,
      embedded: u,
      tag: h,
      $slots: n
    } = this;
    return d == null || d(), s(h, {
      class: [`${e}-card`, this.themeClass, u && `${e}-card--embedded`, {
        [`${e}-card--rtl`]: g,
        [`${e}-card--content${typeof o != "boolean" && o.content === "soft" ? "-soft" : ""}-segmented`]: o === !0 || o !== !1 && o.content,
        [`${e}-card--footer${typeof o != "boolean" && o.footer === "soft" ? "-soft" : ""}-segmented`]: o === !0 || o !== !1 && o.footer,
        [`${e}-card--action-segmented`]: o === !0 || o !== !1 && o.action,
        [`${e}-card--bordered`]: f,
        [`${e}-card--hoverable`]: a
      }],
      style: this.cssVars,
      role: this.role
    }, i(n.cover, (r) => {
      const t = this.cover ? c([this.cover()]) : r;
      return t && s("div", {
        class: `${e}-card-cover`,
        role: "none"
      }, t);
    }), i(n.header, (r) => {
      const {
        title: t
      } = this, l = t ? c(typeof t == "function" ? [t()] : [t]) : r;
      return l || this.closable ? s("div", {
        class: [`${e}-card-header`, this.headerClass],
        style: this.headerStyle,
        role: "heading"
      }, s("div", {
        class: `${e}-card-header__main`,
        role: "heading"
      }, l), i(n["header-extra"], (C) => {
        const m = this.headerExtra ? c([this.headerExtra()]) : C;
        return m && s("div", {
          class: [`${e}-card-header__extra`, this.headerExtraClass],
          style: this.headerExtraStyle
        }, m);
      }), this.closable && s(ee, {
        clsPrefix: e,
        class: `${e}-card-header__close`,
        onClick: this.handleCloseClick,
        absolute: !0
      })) : null;
    }), i(n.default, (r) => {
      const {
        content: t
      } = this, l = t ? c(typeof t == "function" ? [t()] : [t]) : r;
      return l && s("div", {
        class: [`${e}-card__content`, this.contentClass],
        style: this.contentStyle,
        role: "none"
      }, l);
    }), i(n.footer, (r) => {
      const t = this.footer ? c([this.footer()]) : r;
      return t && s("div", {
        class: [`${e}-card__footer`, this.footerClass],
        style: this.footerStyle,
        role: "none"
      }, t);
    }), i(n.action, (r) => {
      const t = this.action ? c([this.action()]) : r;
      return t && s("div", {
        class: `${e}-card__action`,
        role: "none"
      }, t);
    }));
  }
});
export {
  be as cardBasePropKeys,
  S as cardBaseProps,
  re as cardProps,
  pe as default
};
